import {TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import makeStyles from "@mui/styles/makeStyles";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import ClearIcon from '@mui/icons-material/Clear';
const searchStyle = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "nowrap",
        flexDirection: "row",
        alignItems: "center",
        "& fieldset": {
            border: "none",
        },
    },
    icon: {
        marginRight: -10,
    },
    font: {
        fontFamily: "Inter",
        fontWeight: 500,
        fontSize: 12
    },
    clearIcon: {
        cursor: "pointer"
    }
}));

const AgyleSimpleSearchField = (props) => {
    const classes = searchStyle();

    const [valueText, setValueText] = useState("");

    useEffect(() => {
        setValueText(props.value);
    }, [props.value]);

    const handleChange = (e) => {
        const {value} = e.target;
        if (!props.debounce) props.onChange(value);
        if (props.debounce) setValueText(value);
    };

    const handleChangeDebounce = (e) => {
        if (props.debounce) {
            const {value} = e.target;
            props.onChange(value);
        }
    };

    const clearValue = () => {
        if (!props.debounce) props.onChange("");
        if (props.debounce) setValueText("");
    }

    return (
        <div className={classes.root}>
            <SearchIcon fontSize={props.searchIconSize} className={classes.icon}/>
            <TextField
                placeholder={props.placeholder}
                onChange={handleChange}
                onBlur={handleChangeDebounce}
                size={props.size}
                variant="outlined"
                onFocus={props.handleOnFocus}
                disabled={props.disabled}
                error={props.error}
                fullWidth
                margin={props.margin || "dense"}
                value={valueText}
                InputProps={{
                    endAdornment: (props.clearIcon && valueText)? <ClearIcon className={classes.clearIcon} onClick={clearValue} fontSize={"small"}/>: null,
                    classes: {
                        input: classes.font,
                    },
                }}
            />
        </div>
    )
}

export default AgyleSimpleSearchField;

AgyleSimpleSearchField.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    size: PropTypes.oneOf(["small", "medium"]),
    disabled: PropTypes.bool,
    debounce: PropTypes.bool,
    error: PropTypes.bool,
    handleOnFocus: PropTypes.func,
    searchIconSize: PropTypes.string,
    margin: PropTypes.string,
    clearIcon: PropTypes.bool
};

AgyleSimpleSearchField.defaultProps = {
    placeholder: "",
    value: "",
    size: "small",
    disabled: false,
    debounce: false,
    error: false,
    searchIconSize: "large",
        clearIcon: false
};